export default __webpack_public_path__ + "static/media/ladyoflourdes.89d90d1c.jpg";